// extracted by mini-css-extract-plugin
module.exports = {"video":"styles-module--video--1bG_f","locked":"styles-module--locked--6dxom"};